import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import SCHOOLS_DETAILS from '../constants/SchoolsDetails';

import Big from 'big.js';

import SearchingImage from '../../img/searching.png';


import "../../css/SchoolMatcher.css"
import Logo from '../components/Logo';
import Footer from '../components/Footer';
import CallToDonate from '../components/CallToDonate';
import ClusterSchoolBlock from '../components/ClusterSchoolBlock';



const SchoolMatcher = () => {

	const [radiusFromSchool, setRadiusFromSchool] = useState(1);
	const [blacklistedSchools, setBlacklistedSchools] = useState([]);
	const [isSearching, setIsSearching] = useState(false);
	const [clusterResultsArray, setClusterResultsArray] = useState([]);

	useEffect(()=>{
		setIsSearching(true);
		calculateClusterSchools(radiusFromSchool, targetTotalSETHours, singleOrAny)

		 // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [blacklistedSchools])

	const history = useHistory();

	const resultsContainerRef = useRef(null)

	let schoolSlug = useParams().schoolRollNumberSlug;
	const schoolArray = SCHOOLS_DETAILS.filter(schoolEntry => schoolEntry.rollNumber === schoolSlug);
	const selectedSchoolObj = schoolArray[0];
	let singleOrAny = useParams().options ? true : false;

	let hoursSlug = useParams().targetTotalSETHoursSlug;
	let targetTotalSETHours;
	if (hoursSlug === "recommended") {
		targetTotalSETHours = new Big(selectedSchoolObj.SETHours).mod(25).minus(25).abs().toNumber();
	} else {
		targetTotalSETHours = new Big(hoursSlug).toNumber();
	}

	/* 
		Distance between two lat/lng coordinates in km using the Haversine formula
		from https://simplemaps.com/resources/location-distance
	*/
	const getDistanceFromLatLng = (lat1, lng1, lat2, lng2) => {
		function deg2rad(deg){return deg * (Math.PI/180);}
		function square(x){return Math.pow(x, 2);}
		const r=6371; // radius of the earth in km
		lat1=deg2rad(lat1);
		lat2=deg2rad(lat2);
		const lat_dif=lat2-lat1;
		const lng_dif=deg2rad(lng2-lng1);
		const a=square(Math.sin(lat_dif/2))+Math.cos(lat1)*Math.cos(lat2)*square(Math.sin(lng_dif/2));
		const d=2*r*Math.asin(Math.sqrt(a));
		return d;
	}

	const getNearbySchools = (selectedSchoolObj, blacklistedSchools, radiusFromSchool) => {
		let validNearbySchools = SCHOOLS_DETAILS.filter(schoolEntry => 
			schoolEntry.i !== selectedSchoolObj.i && !blacklistedSchools.includes(schoolEntry.schoolName) && getDistanceFromLatLng(selectedSchoolObj.lat, selectedSchoolObj.lng, schoolEntry.lat, schoolEntry.lng) < radiusFromSchool
		)
		
		validNearbySchools.map(schoolEntry =>
			schoolEntry.distFromTarget = Number(getDistanceFromLatLng(selectedSchoolObj.lat, selectedSchoolObj.lng, schoolEntry.lat, schoolEntry.lng).toFixed(2))
		)

		return validNearbySchools.sort(function (a, b) {
			return a.distFromTarget - b.distFromTarget
		})
	}


	const calculateClusterSchools = (currentRadiusFromSchool, targetTotalSETHours, singleOrAny) => {
		
		let nearbySchools = [];
		let possibleClusterSchools = [];

		const preparePossibleCusterSchools = (selectedSchoolObj, blacklistedSchools, targetTotalSETHours) => {
			nearbySchools = getNearbySchools(selectedSchoolObj, blacklistedSchools, currentRadiusFromSchool);
			nearbySchools.forEach(schoolEntry => {
				schoolEntry.SETLeftOver = isNaN(schoolEntry.SETHours) ? 0 : new Big(schoolEntry.SETHours).mod(25).toNumber()
			})
			return nearbySchools.filter(schoolEntry => 
				schoolEntry.SETLeftOver <= targetTotalSETHours && schoolEntry.SETLeftOver !== 0
			)
		}
		
		let clusterCalculatorWorker = new Worker('./workers/worker.js');
		possibleClusterSchools = preparePossibleCusterSchools(selectedSchoolObj, blacklistedSchools, targetTotalSETHours);

		clusterCalculatorWorker.postMessage([possibleClusterSchools, targetTotalSETHours, singleOrAny]);
		clusterCalculatorWorker.onmessage = function(e) {
			if (e.data === "noMatches" && currentRadiusFromSchool <= 49) {
				currentRadiusFromSchool++
				setRadiusFromSchool(currentRadiusFromSchool);
				possibleClusterSchools = preparePossibleCusterSchools(selectedSchoolObj, blacklistedSchools, targetTotalSETHours);
				clusterCalculatorWorker.postMessage([possibleClusterSchools, targetTotalSETHours, singleOrAny]);
			} else {
				setIsSearching(false);
				setClusterResultsArray([...e.data]);
				clusterCalculatorWorker.terminate();
				resultsContainerRef.current.scrollIntoView({behavior: "smooth"})
			}
		}
		
	}

	return(
		<div>
			<Logo
				onClick={() => history.push("/")}
				showRetry={"yes"}
			>{selectedSchoolObj.schoolName}</Logo>
			<div id="selectedSchoolData">
				<h2>You have {new Big(targetTotalSETHours).minus(25).abs().toString()} {hoursSlug !== "recommended" ? "custom" : "leftover"} SET Allocation hours.</h2>
				<h2>You need to find <span className="color-highlight">{targetTotalSETHours} hours</span> to match with.</h2>
			</div>
			<hr/>
			<div id="resultsContainer" ref={resultsContainerRef}>
				{isSearching ?
					<>
						<img id="searchingIcon" src={SearchingImage} alt="Searching..."/>
						<h2>Trying {radiusFromSchool}km from your school</h2>
						{radiusFromSchool > 24 &&
							<p><em>Each extra km adds a lot of extra maths... Please be patient!</em></p>
						}
					</>
				: clusterResultsArray[0] !== "n" ?
					<div id="successMessage">
						<header>
							<CallToDonate/>
							<h2>We found a <mark>{clusterResultsArray.length} school cluster</mark> within a <mark>{radiusFromSchool}km radius</mark> from you</h2>
							
						</header>
						<div className='SchoolCluster'>
							{clusterResultsArray.map(clusterSchool =>
								
								<ClusterSchoolBlock
									clusterSchool={clusterSchool}
									setBlacklistedSchools={setBlacklistedSchools}
									blacklistedSchools={blacklistedSchools}
									key={clusterSchool.rollNumber}
								/>
								
							)}
						</div>
						
					</div>
				:
					<div id="failureMessage">
						<h1>=(</h1>
						<h2>Oh dear!</h2>
						<h3>We couldn't find you a cluster within {radiusFromSchool}km of your school :(</h3>
						<h3>
							{blacklistedSchools.length !== 0 ?
								<span>You can <span className="try-again clickable" onClick={e => {setRadiusFromSchool(1); setBlacklistedSchools([]);}}>start from scratch</span> or c</span>
							: "C"
							}
						heck out <a href="https://assets.gov.ie/283034/7cd0fd6f-e209-4b7e-81e8-c700bdf356d0.xlsx">the DES data</a> for yourself</h3> 
					</div>
				}
			</div>
			<Footer
				isRelative={!isSearching && clusterResultsArray[0] !== "n" ? true : false}
			/>
		</div>
	)
}

const mapStateToProps = state => ({
	selectedSchoolIndex: state.selectedSchoolIndexState
})


const mapDispatchToProps = dispatch => ({
})

export default connect(
	mapStateToProps, 
	mapDispatchToProps,
)(SchoolMatcher);
